import React, { useEffect, useMemo } from "react";
import { withMonogramContext } from "./MonogramContext";
import MonogramSwatches from "./MonogramSwatches";
import MonogramSettingHeader from "./MonogramSettingHeader";

function MonogramDecorativeColor({
  chosenFont,
  setChosenDecorativeColor,
  chosenDecorativeColor,
  threadColorSwatches,
  language,
  getThreadColorSwatch,
  setUserActions,
  userActions,
}) {
  const swatches = useMemo(() => {
    return chosenFont.thread_colors.map((color) => {
      const associatedThreadColorSwatch = getThreadColorSwatch(color);

      return {
        limitedEdition: associatedThreadColorSwatch?.limited_edition,
        imageSrc: associatedThreadColorSwatch?.thread_color_swatch,
        selected: chosenDecorativeColor?.thread_color_name === color,
        alt: color,
        value: associatedThreadColorSwatch,
      };
    });
  }, [chosenFont, threadColorSwatches, chosenDecorativeColor]);

  const standardSwatches = useMemo(
    () => swatches.filter((swatch) => !swatch.limitedEdition),
    [swatches]
  );
  const limitedEditionSwatches = useMemo(
    () => swatches.filter((swatch) => swatch.limitedEdition),
    [swatches]
  );
  const chosenThreadColorIsLimitedEdition = useMemo(
    () =>
      limitedEditionSwatches.some(
        (swatch) => swatch.value.thread_color_name === chosenDecorativeColor?.thread_color_name
      ),
    [limitedEditionSwatches, chosenDecorativeColor]
  );

  function handleSwatchChange(value) {
    setChosenDecorativeColor(value);
    setUserActions((prev) => ({ ...prev, hasSelectedDecorativeColor: true }));
  }

  return (
    <>
      {standardSwatches.length > 0 && (
        <>
          <MonogramSettingHeader
            title={language.decorative_color}
            subtitlePrefix={language.decorative_color_subtitle}
            subtitle={
              !chosenThreadColorIsLimitedEdition && userActions.hasSelectedDecorativeColor
                ? chosenDecorativeColor?.thread_color_name
                : ""
            }
          />
          <MonogramSwatches
            swatches={standardSwatches}
            selectSwatch={handleSwatchChange}
            stretchImages
            shouldSelect={userActions.hasSelectedDecorativeColor}
          />
        </>
      )}

      {limitedEditionSwatches.length > 0 && (
        <>
          <MonogramSettingHeader
            subtitlePrefix={language.limited_edition_thread_color_subtitle}
            subtitle={
              chosenThreadColorIsLimitedEdition && userActions.hasSelectedDecorativeColor
                ? chosenDecorativeColor?.thread_color_name
                : ""
            }
          />
          <MonogramSwatches
            swatches={limitedEditionSwatches}
            selectSwatch={handleSwatchChange}
            stretchImages
            shouldSelect={userActions.hasSelectedDecorativeColor}
          />
        </>
      )}
    </>
  );
}

export default withMonogramContext(MonogramDecorativeColor);
